import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.ad-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          arrows: true,
          gap: '20px',
          paginationKeyboard: true,
          drag: true,
          perPage: 2,
          pagination: false,
          breakpoints: {
            768: {
              perPage: 1,
              focus: 'center',
              start: 1,
            },
          },
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            drag: isOverflow,
          };
        } );
        slider.mount( );
      } );
      $( '.ad-slider__mobile-splide' ).each( function( index, element ) {
        const mobileSlider = new Splide( $( element )[0], {
          type: 'loop',
          arrows: true,
          gap: '20px',
          paginationKeyboard: true,
          drag: true,
          perPage: 2,
          pagination: false,
          breakpoints: {
            768: {
              perPage: 1,
              focus: 'center',
              start: 1,
            },
          },
        } );
        mobileSlider.on( 'overflow', function( isOverflow ) {
          mobileSlider.options = {
            drag: isOverflow,
          };
        } );
        mobileSlider.mount( );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'ad-slider', COMPONENT );
} )( app );
